module.exports = __webpack_public_path__ + "media/images/ir/message/bg-6d86703af5bb72ef65e620e0ce817530.jpg";